module.exports = __webpack_public_path__ + "static/media/19.2d9de189.JPG";